namespace TabAurous.OMS {
    export interface CitiesMasterRow {
        Id?: number;
        Name?: string;
        StateId?: number;
    }

    export namespace CitiesMasterRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'OMS.CitiesMaster';
        export const lookupKey = 'OMS.CitiesMaster';

        export function getLookup(): Q.Lookup<CitiesMasterRow> {
            return Q.getLookup<CitiesMasterRow>('OMS.CitiesMaster');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            StateId = "StateId"
        }
    }
}
